import React, { useEffect, useRef, useState } from 'react';
import { Typography } from "../../index";
import './button_group.scss';

export const ButtonGroupItem = ({
    disabled,
    error,
    label,
    onClick,
    selected,
    size = "sm",
    value,
}) => {

    const handleOnClick = (e, value) => {
        if (onClick) {
            onClick(e, value);
        }
    }

    const buttonGroupItemClasses = [
        `bsw-button-group-item`,
        `bsw-button-group-item--size-${size ? size : 'sm'}`,
        `${selected ? 'bsw-button-group-item--selected' : ''}`,
        `${error ? 'bsw-button-group-item--error' : ''}`,
        `${disabled ? 'bsw-button-group-item--disabled' : ''}`
    ].join(' ');

    return (
        <button
            type="button"
            className={buttonGroupItemClasses}
            onClick={(e) => handleOnClick(e, value)}
            disabled={disabled}
        >
            <div className="bsw-button-group__label">
                <Typography
                    color={disabled ? "$color-secondary-a3" : "$color-secondary-a2"}
                    type="meta-02"
                    tag="div"
                    textAlign="center"
                >
                    {label}
                </Typography>
            </div>
        </button>
    )
}